var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8319_28792)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71875 10C6.71875 9.56853 7.06853 9.21875 7.5 9.21875H12.5C12.9315 9.21875 13.2812 9.56853 13.2812 10C13.2812 10.4315 12.9315 10.7812 12.5 10.7812H7.5C7.06853 10.7812 6.71875 10.4315 6.71875 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7188 5C11.7188 4.56853 12.0685 4.21875 12.5 4.21875H13.3333C14.8666 4.21875 16.3371 4.82784 17.4213 5.91204C18.5055 6.99623 19.1146 8.46672 19.1146 10C19.1146 11.5333 18.5055 13.0038 17.4213 14.088C16.3371 15.1722 14.8666 15.7812 13.3333 15.7812H12.5C12.0685 15.7812 11.7188 15.4315 11.7188 15C11.7188 14.5685 12.0685 14.2188 12.5 14.2188H13.3333C14.4522 14.2188 15.5253 13.7743 16.3164 12.9831C17.1076 12.1919 17.5521 11.1189 17.5521 10C17.5521 8.88112 17.1076 7.80806 16.3164 7.01689C15.5253 6.22572 14.4522 5.78125 13.3333 5.78125H12.5C12.0685 5.78125 11.7188 5.43147 11.7188 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66602 5.78125C5.54713 5.78125 4.47408 6.22572 3.68291 7.01689C2.89174 7.80806 2.44727 8.88112 2.44727 10C2.44727 11.1189 2.89174 12.1919 3.68291 12.9831C4.47408 13.7743 5.54713 14.2188 6.66602 14.2188H7.49935C7.93082 14.2188 8.2806 14.5685 8.2806 15C8.2806 15.4315 7.93082 15.7812 7.49935 15.7812H6.66602C5.13273 15.7812 3.66225 15.1722 2.57805 14.088C1.49386 13.0038 0.884766 11.5333 0.884766 10C0.884766 8.46672 1.49386 6.99623 2.57805 5.91204C3.66225 4.82784 5.13273 4.21875 6.66602 4.21875H7.49935C7.93082 4.21875 8.2806 4.56853 8.2806 5C8.2806 5.43147 7.93082 5.78125 7.49935 5.78125H6.66602Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8319_28792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLink);
export default __webpack_public_path__ + "static/media/smallLink.78ee4597.svg";
export { ForwardRef as ReactComponent };